module.exports = __webpack_public_path__ + "static/media/reliable.28703454.svg";